import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import React, { useEffect, useRef, useState } from "react";
import mContentLogo from "../../assets/images/mContentLogo.png";
import WalletConnectLogo from "../../assets/images/walletConnect.png";
import HelpLogo from "../../assets/svgs/help.svg";
import ConnectWalletButton from "../Buttons/ConnectWallet/ConnectWalletButton";
import ConnectWalletModal from "../Modals/ConnectWalletModal/ConnectWalletModal.jsx";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import { conciseAddress } from "../../utils/formatters";
import useStyles from "./navbarStyles.js";
import Web3 from "web3";
import {
  ClickAwayListener,
  Grow,
  ListItemIcon,
  ListItemText,
  MenuList,
  Paper,
  Popper,
} from "@material-ui/core";
import BinanceLogo from "../../assets/svgs/binanceLogo.svg";
import EthereumLogo from "../../assets/svgs/ethereumLogo.svg";
import DownArrow from "../../assets/svgs/downArrow.svg";
import MetamaskLogo from "../../assets/images/MetamaskLogo.png";
import DisconnectWallet from "../Modals/DisconnectWallet/DisconnectWallet";
import { switchNetwork } from "../../utils/web3Connectors";
import millify from "millify";
import { toast } from "react-toastify";
import Notify from "../Toast/Notify";
import { chains, mContentLink, supportedChains } from "../../contract/constant";
import { InjectedConnector } from "@web3-react/injected-connector";
import WrongNetworkModal from "../Modals/WrongNetwork/WrongNetworkModal";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";

function Navbar({userBalance}) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [isDisconnectModalOpen, setIsDisconnectModalOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [buttonText, setButtonText] = useState("Connect Wallet");
  const [wrongNetworkOpen, setWrongNetworkOpen] = useState(false);
  const [web3State, setWeb3State] = useState(null);
  const { active, account, library, connector, activate, deactivate, chainId } =
    useWeb3React();
  const toastIdNetwork = useRef(null);
  const anchorRef = useRef(null);


  // useEffect(async ()=>{
  //   const web3 =await new Web3(library?.currentProvider?library?.currentProvider:"https://mainnet.infura.io/v3/3c62e62341b34568a512b8917a59ad63");
  //   console.log("hello web3",await web3.eth.net.getId())
  //   await setWeb3State(web3);
  // },[])
  useEffect(async () => {
    // if(localStorage.getItem("previousWallet")=="metaMask"){
      const wallet = window.localStorage.getItem("previousWallet");
      if(wallet == "metaMask"){
        walletTextFunctionMetamask();
      }
      else if(wallet == "walletConnect"){
        walletTextFunctionWalletConnect();
      }
  }, [chainId]);
  const handleToggle = () => {
    setMenuOpen((prevOpen) => !prevOpen);
  };
  const prevOpen = useRef(menuOpen);
  useEffect(() => {
    if (prevOpen.current === true && menuOpen === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = menuOpen;
  }, [menuOpen]);

  const handleWrongNetworkOpen = () => {
    setWrongNetworkOpen(true);
  };
const walletTextFunctionWalletConnect = () =>{
  if (
    connector &&
    connector instanceof WalletConnectConnector 
    // connector.walletConnectProvider?.wc?.uri
    ) {
      connector.walletConnectProvider = undefined
    }
  activate(
    connector
      ? connector
      : new InjectedConnector({
          // supportedChainIds: [1, 4],
          supportedChainIds: supportedChains,
        }),
    undefined,
    true
  )
    .then(() => {
      setButtonText("Connect Wallet");
      localStorage.setItem("wrongWallet",false)
    })
    .catch((e) => {
      if (e instanceof UnsupportedChainIdError) {
        setButtonText("Wrong Network");
        localStorage.setItem("wrongWallet",true)
      }
      else{
        localStorage.setItem("wrongWallet",false)
      }
    });
}
  const walletTextFunctionMetamask = () => {
    activate(
      connector
        ? connector
        : new InjectedConnector({
            // supportedChainIds: [1, 4],
            supportedChainIds: supportedChains,
          }),
      undefined,
      true
    )
      .then(() => {
        setButtonText("Connect Wallet");
        localStorage.setItem("wrongWallet",false)
      })
      .catch((e) => {
        if (e instanceof UnsupportedChainIdError) {
          setButtonText("Wrong Network");
          localStorage.setItem("wrongWallet",true)
        }
        else{
          localStorage.setItem("wrongWallet",false)
        }
      });
  };
  const handleMenuClose = async (event) => {
    try {
      const { myValue } = event.currentTarget.dataset;
      if (chainId != myValue) {
        if (myValue) {
          switchNetwork(parseInt(myValue));
        }
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
          return;
        }
      } else {
        if (!toast.isActive(toastIdNetwork.current)) {
          toast.update(toastIdNetwork, {
            autoClose: 5000,
          });
          toastIdNetwork.current = toast(
            <Notify
              text={`You are already on the ${
                chainId == supportedChains[0] ? "Etheruem" : "Binance"
              } Network.`}
              severity="success"
            />,
            {
              position: "bottom-right",
              autoClose: 5000,
            }
          );
        }
      }
    } catch (e) {}

    setMenuOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setMenuOpen(false);
    }
  }
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDisconnect = () => {
    setIsDisconnectModalOpen(!isDisconnectModalOpen);
  };
  return (
    <div className={classes.navbar}>
      <div className={classes.navbarMaterial}>
        <div className={classes.logoDiv}>
          <a href={mContentLink} style={{ textDecoration: "none" }}>
            <img src={mContentLogo} className={classes.mContentLogo} />
          </a>
        </div>
        <div className={classes.marginLeftAuto}>
          {active ? (
            <div className={classes.root}>
              <div style={{ display: "flex" }}>
                <div>
                  <Button
                    ref={anchorRef}
                    aria-controls={open ? "menu-list-grow" : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                    className={classes.chainButton}
                  >
                    <div className={classes.downDrop}>
                      <div style={{ paddingRight: "5px", display: "flex" }}>
                        {chainId == supportedChains[0] ? (
                          <img
                            src={EthereumLogo}
                            className={classes.chainIconHeight}
                          />
                        ) : (
                          <img
                            src={BinanceLogo}
                            className={classes.chainIconHeight}
                          />
                        )}
                      </div>
                      <div>
                        <img
                          src={DownArrow}
                          className={classes.downArrowIcon}
                        />
                      </div>
                    </div>
                  </Button>
                </div>
                <div onClick={handleDisconnect}>
                  <div style={{}} className={classes.navbarAddress}>
                    <div className={classes.navbarMetamask}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: " 2px 0px",
                        }}
                      >
                        <img
                          src={(window.localStorage.getItem("previousWallet")=="metaMask")?MetamaskLogo:window.localStorage.getItem("previousWallet")=="walletConnect"&&WalletConnectLogo}
                          style={{ height: "35px", width: "35px" }}
                        />
                      </div>
                      <div>{`${userBalance} ${
                        supportedChains[0] == chainId ? "ETH" :supportedChains[1] == chainId? "BNB":""
                      }`}</div>
                    </div>
                    <div
                      className={classes.accountAddress}
                      style={{ padding: "9px 10px" }}
                    >
                      {conciseAddress(account)}
                    </div>
                  </div>
                </div>
                {/* <div className={classes.help}>
                  <img src={HelpLogo} />
                </div> */}
                <DisconnectWallet
                  handleClose={handleDisconnect}
                  open={isDisconnectModalOpen}
                />
                <Popper
                  open={menuOpen}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  style={{ zIndex: "4", transformOrigin: "left", left: "50px" }}
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      style={{
                        transformOrigin:
                          placement === "bottom" ? "left" : "left",
                        //  left:"50px"
                      }}
                      className={classes.leftNetworkDropDown}
                      {...TransitionProps}
                    >
                      <Paper
                        style={{
                          borderRadius: "20px",
                          padding: "10px 0px",

                          position: "relative",
                          width: "200px",
                          background: "#FFFFFF",
                          boxShadow: "0px 4px 30px rgba(13, 13, 13, 0.1)",
                          borderRadius: "12px",
                          zIndex: "1",
                        }}
                      >
                        <ClickAwayListener
                          onClickAway={handleMenuClose}
                          value={chainId}
                        >
                          <MenuList
                            autoFocusItem={open}
                            id="menu-list-grow"
                            onKeyDown={handleListKeyDown}
                            // getContentAnchorEl={null}
                            // anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                            // transformOrigin={{vertical: 'top', horizontal: 'right'}}
                          >
                            <div
                              style={{
                                textAlign: "center",
                                marginBottom: "10px",
                                fontSize: "16px",
                                lineHeight:
                                  "23px" /* identical to box height */,

                                /* Wireframe/Blue/Secondary */

                                color: "#282828",
                                fontWeight: "600",
                                opacity: "0.9",
                              }}
                            >
                              Select a Network
                            </div>
                            <MenuItem
                              onClick={(e) => {
                                handleMenuClose(e);
                              }}
                              data-my-value={supportedChains[0]}
                              value={supportedChains[0]}
                              style={{
                                background: `${
                                  (chainId ==supportedChains[0]) && "#60B7FF1A"
                                }`,
                              }}
                            >
                              <ListItemIcon className={classes.networkIcon}>
                                <img src={EthereumLogo} />
                              </ListItemIcon>
                              <ListItemText className={classes.menuItem}>
                                Ethereum
                              </ListItemText>
                            </MenuItem>
                            <MenuItem
                              onClick={(e) => {
                                handleMenuClose(e);
                              }}
                              data-my-value={supportedChains[1]}
                              value={supportedChains[1]}
                              style={{
                                background: `${
                                  (chainId == supportedChains[1]) &&
                                  "#60B7FF1A"
                                }`,
                              }}
                            >
                              <ListItemIcon className={classes.networkIcon}>
                                <img src={BinanceLogo} />
                              </ListItemIcon>
                              <ListItemText className={classes.menuItem}>
                                Binance
                              </ListItemText>
                            </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
            </div>
          ) : (
            <>
              <ConnectWalletButton
                text={
                  buttonText == "Connect Wallet"
                    ? "Connect Wallet"
                    : "Wrong Network"
                }
                handleOpen={
                  buttonText == "Connect Wallet"
                    ? handleOpen
                    : handleWrongNetworkOpen
                }
                handleClose={handleClose}
                open={open}
              />
              <ConnectWalletModal
                handleOpen={handleOpen}
                handleClose={handleClose}
                open={open}
                text={"Connect Wallet"}
              />
              <WrongNetworkModal
                wrongNetworkOpen={wrongNetworkOpen}
                setWrongNetworkOpen={setWrongNetworkOpen}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Navbar;
